import React from "react";
import Hero from "../components/Hero";
import RoomCarousel from "../components/RoomCarousel";
import RoomDescription from "../components/RoomDescription";

const Home = () => {
  return (
    <div>
      <Hero />
      <RoomCarousel />
      <RoomDescription />
    </div>
  );
};

export default Home;
